import React from "react";

import { Dialog, DialogContent, makeStyles } from "@material-ui/core";

import { ModalDialogTitle } from "./ModalDialogTitle";

const useStyles = makeStyles((theme) => ({
  mobile: {
    [theme.breakpoints.only("xs")]: {
      padding: theme.spacing(3, 0, 0, 0),
    },
  },
  md: {
    width: "30rem",
  },
}));

type ModalDialogProps = {
  modalOpen: boolean;
  handleClose: () => void;
  children: React.ReactNode;
  maxWidth: "xs" | "sm" | "md" | "lg" | "xl";
  icon: JSX.Element;
  title: JSX.Element;
};

export default function ModalDialog({
  maxWidth: maxWidth,
  modalOpen,
  handleClose,
  children,
  icon,
  title,
}: ModalDialogProps) {
  const classes = useStyles();

  return (
    <Dialog
      open={modalOpen}
      onClose={handleClose}
      maxWidth={maxWidth}
      classes={{ paperWidthMd: classes.md }}
      className={classes.mobile}
    >
      <ModalDialogTitle id="dialog-title" onClose={handleClose}>
        {icon}
        {title}
      </ModalDialogTitle>
      <DialogContent dividers>{children}</DialogContent>
    </Dialog>
  );
}
